import { FC } from "react";

type PagewideMessageDisplayProps = {
  title: string;
  description: string;
};

const PagewideMessageDisplay: FC<PagewideMessageDisplayProps> = ({
  title,
  description,
}) => {
  return (
    <div className="col-span-8 h-[calc(100vh-160px)] p-28 text-center">
      <h2 className="font-bold text-2xl text-gray-400">{title}</h2>
      <p className="text-gray-400">{description}</p>
    </div>
  );
};
export default PagewideMessageDisplay;
